import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";

const UserDetail = (props) => {
    const {rows, columns} = props;

  return (
    <Box sx={{ width: '100%', padding: '20px', cursor: 'pointer'}}>
      <DataGrid
        rows={rows}
        columns={columns}
        disableColumnMenu
        disableColumnReorder
        disableSelectionOnClick
        pageSizeOptions={[20]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 20,
            },
          },
        }}
        sx={{
          width: '100%',
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "700",
            color: '#1976d2',
          },
        }}
      />

    </Box>
  );
}

export default UserDetail;